import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { KeyRound, User as UserIcon } from "lucide-react";

export default function AdminPerfil() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) return toast.error("La nueva contraseña debe tener al menos 6 caracteres");
    if (form.new_password !== form.confirm) return toast.error("La confirmación no coincide");
    if (form.new_password === form.current_password) return toast.error("La nueva contraseña no puede ser igual a la actual");
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Contraseña actualizada");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-perfil">
      <header>
        <h1 className="font-display font-black text-3xl">Mi perfil</h1>
        <p className="text-muted-foreground">Gestiona tus datos y seguridad.</p>
      </header>

      <section className="bg-white rounded-2xl border border-border p-6 max-w-xl">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-full bg-primary/10 text-primary grid place-items-center">
            <UserIcon size={20} />
          </div>
          <div>
            <div className="font-display font-bold">{user?.name}</div>
            <div className="text-sm text-muted-foreground">{user?.email} · <span className="capitalize">{user?.role}</span></div>
          </div>
        </div>
      </section>

      <section className="bg-white rounded-2xl border border-border p-6 max-w-xl">
        <div className="flex items-center gap-2 mb-4">
          <KeyRound size={18} className="text-primary" />
          <h2 className="font-display font-bold">Cambiar contraseña</h2>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="password-form">
          <Field label="Contraseña actual" type="password" value={form.current_password} onChange={(v) => setForm((f) => ({ ...f, current_password: v }))} testid="pw-current" />
          <Field label="Nueva contraseña (mín. 6)" type="password" value={form.new_password} onChange={(v) => setForm((f) => ({ ...f, new_password: v }))} testid="pw-new" />
          <Field label="Repite la nueva contraseña" type="password" value={form.confirm} onChange={(v) => setForm((f) => ({ ...f, confirm: v }))} testid="pw-confirm" />
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-primary text-primary-foreground py-3 rounded-full font-bold hover:brightness-110 disabled:opacity-60 transition"
            data-testid="pw-submit-btn"
          >
            {busy ? "Actualizando…" : "Actualizar contraseña"}
          </button>
        </form>
      </section>
    </div>
  );
}

function Field({ label, type, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="block text-sm font-bold mb-1">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        className="w-full rounded-xl border border-border bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-ring"
        data-testid={testid}
      />
    </label>
  );
}
